'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _class = require('common/utils/class');

function BaseNotifier() {}

(0, _class.extend)(BaseNotifier, {
    notify: function notify(message) {
        // OVERRRIDE ME
    }
});

BaseNotifier.create = _class.create;
BaseNotifier.extend = _class.extend;

exports['default'] = BaseNotifier;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/notifiers/base.js
 ** module id = 594
 ** module chunks = 0
 **/